export enum COUNTRY_TYPES {
    SUPPORTED_BY,
    SUPPORTED_BY_PARTNER,
    RECOMMENDED_DEALER,
    LOCATION,
    HEAD_OFFICE,
    SALES_PARTNER,
    SALES_SERVICE_PARTNER,
}

export interface ResponseCountry {
    code: string;
    name: string;
    supported_by: SupportedByResponse;
    recommended_dealer: CountryAddress;
    location: CountryAddress;
    languages: Language[];
    sales_partner: CountryAddress;
    sales_service_partner: CountryAddress;
    type: COUNTRY_TYPES;
}

interface SupportedByResponse {
    code: string;
    country: string;
    languages: Language[];
    address: Address;
}

export interface Language {
    code: string;
    name: string;
    url: string;
}

export interface Address {
    lines: string[];
    tel: string;
    fax: string;
    url: string;
    email: string;
}

export interface SupportedBy {
    code: string;
    country: string;
    languages: Language[];
}

export interface SupportedByPartner {
    code: string;
    country: string;
    address: Address;
}

export interface CountryAddress {
    address: Address;
}

export interface BaseCountry {
    code: string;
    name: string;
}

export interface SupportyByCountry extends BaseCountry {
    type: COUNTRY_TYPES.SUPPORTED_BY;
    data: SupportedBy;
}

export interface SupportyByPartnerCountry extends BaseCountry {
    type: COUNTRY_TYPES.SUPPORTED_BY_PARTNER;
    data: SupportedByPartner;
}

export interface RecommendedDealerCountry extends BaseCountry {
    type: COUNTRY_TYPES.RECOMMENDED_DEALER;
    data: CountryAddress;
}

export interface LocationCountry extends BaseCountry {
    type: COUNTRY_TYPES.LOCATION;
    data: CountryAddress;
}

export interface SalesPartnerCountry extends BaseCountry {
    type: COUNTRY_TYPES.SALES_PARTNER;
    data: CountryAddress;
}

export interface SalesServicePartnerCountry extends BaseCountry {
    type: COUNTRY_TYPES.SALES_SERVICE_PARTNER;
    data: CountryAddress;
}

export interface HeadOfficeCountry extends BaseCountry {
    type: COUNTRY_TYPES.HEAD_OFFICE;
    languages?: Language[];
}

export type Country =
    | SupportyByCountry
    | SupportyByPartnerCountry
    | RecommendedDealerCountry
    | LocationCountry
    | SalesPartnerCountry
    | SalesServicePartnerCountry
    | HeadOfficeCountry;
